import { FC } from "react";
import Box from "@mui/material/Box";
import Fade from "@mui/material/Fade";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import SearchOffIcon from "@mui/icons-material/SearchOff";

export const ExportHistoryEmpty: FC = () => {
  return (
    <Fade in={true} timeout={400}>
      <Box sx={{ py: 12 }}>
        <Stack direction="column" alignItems="center" spacing={4}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="center"
            width={120}
            height={120}
            borderRadius="50%"
            bgcolor="grey.100"
            color="grey.400"
          >
            <SearchOffIcon sx={{ fontSize: 100 }} />
          </Stack>
          <Typography
            variant="h4"
            align="center"
            color="text.primary"
            fontWeight={600}
          >
            No exports found
          </Typography>
          <Typography variant="h6" align="center" color="text.secondary">
            Your export history will appear here once you trigger your first
            export.
          </Typography>
        </Stack>
      </Box>
    </Fade>
  );
};
